import React from 'react';
import '@isyc-react/design/main';
export const TextareaCounterContainer = props => {
  const {
    children,
    show
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, show && /*#__PURE__*/React.createElement("small", {
    className: "d-flex justify-content-end text-muted font-italic mt-2"
  }, children));
};